// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main{
  height: auto;
}

.styles_container__c72Yu{
  width: var(--container-width-md);
  max-width: 1920px;
  margin: auto;
  display: grid;
  grid-template-columns: 51% 49%;

}

.styles_container__c72Yu > div {
  height: 850px;
  left: 764px;
  top: 148px;
  background: #EFF0F8;

}
.styles_aside__Ougus{
  /* position: absolute; */
  width: 440px;
  
}

.styles_section__CJleE{
  margin: 115px 0 0 80px;
  font-style: normal;
  font-weight: 390;
  font-size: 22px;
  line-height: 31px;
  text-align: start;

}

.styles_section__CJleE > div {
  margin-top: 10px;
  display: flex;
  align-items: center;
} 

.styles_section__CJleE > p{
  margin-top: 10px;
}

.styles_section__CJleE > div > img {
    margin-right: 24px;
}

.styles_form__vgf6Q{
  padding-top: 40px;
  width: 540px;
  height: 690px;
  position: absolute;
  top: 160px;
  right: 366px;
  background: #FFFFFF;
  border-top: 8px solid #B88F3E;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;

}

.styles_form__vgf6Q > fieldset{
  margin: auto;
  width: 438px;
}

.styles_form__vgf6Q > fieldset > label {
  font-style: normal;
  font-weight: 450;
  font-size: 20px;
  line-height: 29px;
}

.styles_form__vgf6Q > fieldset > input {
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  width: 438px;
  height: 68px;
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 390;
  font-size: 18px;
  line-height: 26px;
  padding: 12px;
  margin-bottom: 10px;
}

.styles_form__vgf6Q > fieldset > textarea{
  width: 438px;
  height: 176px; 
  padding: 12px; 
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
}

.styles_form__vgf6Q > fieldset > input::placeholder,textarea::placeholder{
  font-style: normal;
  font-weight: 390;
  font-size: 18px;
  line-height: 26px;
  color: #201F1F;
  opacity: 0.5;
}

.styles_form__vgf6Q > fieldset > input:focus, textarea:focus{
  border: 1px solid #B88F3E
  
}

.styles_form__vgf6Q > button{
  margin: 20px auto 40px auto;
  width: 438px;
  height: 41px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Brandon Grotesque';
  cursor: pointer;
  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
  color: var(--color-primary-white);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1512px ){

  .styles_form__vgf6Q{
    right: clamp(199px,19vw,366px);
    
  
  }
}

@media screen and (max-width: 1280px ){

  .styles_container__c72Yu > div{
    display: none;
  }

  .styles_form__vgf6Q{
    position: static;
    margin: auto;
  }

  .styles_container__c72Yu{
    margin: 15px auto;
    row-gap: 15px;
    grid-template-columns: repeat(auto-fit,minmax(540px,1fr));
  }

  .styles_aside__Ougus{
    margin: 0px auto;
  }


/* @media screen and (max-width: 1208px ){

  .container > div{
    display: none;
  }

  .form{
    position: static;
    margin: auto;
  }

  .aside{
    margin: 0px auto;
  }
  .container{
    margin: 15px 0px;
    row-gap: 15px;
    grid-template-columns: repeat(auto-fit,minmax(540px,1fr));
  } */

}

@media screen and (max-width: 820px ){
  .styles_container__c72Yu{
    margin: 15px auto;
  }


  .styles_container__c72Yu{
    margin: 15px auto;
    row-gap: 15px;
    grid-template-columns: repeat(auto-fit,minmax(clamp(337px,90vw,540px),1fr));
  }

  .styles_section__CJleE{
    margin: 60px auto;
    width:clamp(337px,90vw,540px);
  }
  .styles_aside__Ougus{
    width:clamp(337px,90vw,540px);
  }
  .styles_form__vgf6Q{
    width:clamp(337px,90vw,540px);
  
  }
  
  .styles_form__vgf6Q > fieldset{
    margin: 0px auto;
    width:clamp(300px,80vw,438px);
  }
  
  /* .form > fieldset > label {
    font-style: normal;
    font-weight: 450;
    font-size: 20px;
    line-height: 29px;
  } */
  
  .styles_form__vgf6Q > fieldset > input {
    width:clamp(300px,80vw,438px);
  }

  .styles_form__vgf6Q > fieldset > textarea{
    width:clamp(300px,80vw,438px);
  }

  .styles_form__vgf6Q > button{
    width:clamp(300px,80vw,438px);
  }

}

`, "",{"version":3,"sources":["webpack://./src/pages/ContactPage/styles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,mBAAmB;;AAErB;AACA;EACE,wBAAwB;EACxB,YAAY;;AAEd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;AAEnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;EAC3C,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE;;AAEF;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wFAAwF;EACxF,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE;IACE,8BAA8B;;;EAGhC;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,yDAAyD;EAC3D;;EAEA;IACE,gBAAgB;EAClB;;;AAGF;;;;;;;;;;;;;;;;;;KAkBK;;AAEL;;AAEA;EACE;IACE,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB;IACjB,aAAa;IACb,2EAA2E;EAC7E;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;;EAE/B;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;;;;;KAKG;;EAEH;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;AAEF","sourcesContent":["main{\n  height: auto;\n}\n\n.container{\n  width: var(--container-width-md);\n  max-width: 1920px;\n  margin: auto;\n  display: grid;\n  grid-template-columns: 51% 49%;\n\n}\n\n.container > div {\n  height: 850px;\n  left: 764px;\n  top: 148px;\n  background: #EFF0F8;\n\n}\n.aside{\n  /* position: absolute; */\n  width: 440px;\n  \n}\n\n.section{\n  margin: 115px 0 0 80px;\n  font-style: normal;\n  font-weight: 390;\n  font-size: 22px;\n  line-height: 31px;\n  text-align: start;\n\n}\n\n.section > div {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n} \n\n.section > p{\n  margin-top: 10px;\n}\n\n.section > div > img {\n    margin-right: 24px;\n}\n\n.form{\n  padding-top: 40px;\n  width: 540px;\n  height: 690px;\n  position: absolute;\n  top: 160px;\n  right: 366px;\n  background: #FFFFFF;\n  border-top: 8px solid #B88F3E;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 8px;\n\n}\n\n.form > fieldset{\n  margin: auto;\n  width: 438px;\n}\n\n.form > fieldset > label {\n  font-style: normal;\n  font-weight: 450;\n  font-size: 20px;\n  line-height: 29px;\n}\n\n.form > fieldset > input {\n  border: 1px solid #E0E0E0;\n  border-radius: 8px;\n  width: 438px;\n  height: 68px;\n  font-family: 'Brandon Grotesque';\n  font-style: normal;\n  font-weight: 390;\n  font-size: 18px;\n  line-height: 26px;\n  padding: 12px;\n  margin-bottom: 10px;\n}\n\n.form > fieldset > textarea{\n  width: 438px;\n  height: 176px; \n  padding: 12px; \n  background: #FFFFFF;\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n}\n\n.form > fieldset > input::placeholder,textarea::placeholder{\n  font-style: normal;\n  font-weight: 390;\n  font-size: 18px;\n  line-height: 26px;\n  color: #201F1F;\n  opacity: 0.5;\n}\n\n.form > fieldset > input:focus, textarea:focus{\n  border: 1px solid #B88F3E\n  \n}\n\n.form > button{\n  margin: 20px auto 40px auto;\n  width: 438px;\n  height: 41px;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'Brandon Grotesque';\n  cursor: pointer;\n  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n  color: var(--color-primary-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media screen and (max-width: 1512px ){\n\n  .form{\n    right: clamp(199px,19vw,366px);\n    \n  \n  }\n}\n\n@media screen and (max-width: 1280px ){\n\n  .container > div{\n    display: none;\n  }\n\n  .form{\n    position: static;\n    margin: auto;\n  }\n\n  .container{\n    margin: 15px auto;\n    row-gap: 15px;\n    grid-template-columns: repeat(auto-fit,minmax(540px,1fr));\n  }\n\n  .aside{\n    margin: 0px auto;\n  }\n\n\n/* @media screen and (max-width: 1208px ){\n\n  .container > div{\n    display: none;\n  }\n\n  .form{\n    position: static;\n    margin: auto;\n  }\n\n  .aside{\n    margin: 0px auto;\n  }\n  .container{\n    margin: 15px 0px;\n    row-gap: 15px;\n    grid-template-columns: repeat(auto-fit,minmax(540px,1fr));\n  } */\n\n}\n\n@media screen and (max-width: 820px ){\n  .container{\n    margin: 15px auto;\n  }\n\n\n  .container{\n    margin: 15px auto;\n    row-gap: 15px;\n    grid-template-columns: repeat(auto-fit,minmax(clamp(337px,90vw,540px),1fr));\n  }\n\n  .section{\n    margin: 60px auto;\n    width:clamp(337px,90vw,540px);\n  }\n  .aside{\n    width:clamp(337px,90vw,540px);\n  }\n  .form{\n    width:clamp(337px,90vw,540px);\n  \n  }\n  \n  .form > fieldset{\n    margin: 0px auto;\n    width:clamp(300px,80vw,438px);\n  }\n  \n  /* .form > fieldset > label {\n    font-style: normal;\n    font-weight: 450;\n    font-size: 20px;\n    line-height: 29px;\n  } */\n  \n  .form > fieldset > input {\n    width:clamp(300px,80vw,438px);\n  }\n\n  .form > fieldset > textarea{\n    width:clamp(300px,80vw,438px);\n  }\n\n  .form > button{\n    width:clamp(300px,80vw,438px);\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__c72Yu`,
	"aside": `styles_aside__Ougus`,
	"section": `styles_section__CJleE`,
	"form": `styles_form__vgf6Q`
};
export default ___CSS_LOADER_EXPORT___;
